import React from 'react';
import {
	Dialog,
	DialogContent,
	DialogActions,
	FormControlLabel,
	Checkbox,
	Stack,
	List,
	ListItem,
	IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

type ColumnSelectorDialogProps = {
	open: boolean;
	onClose: () => void;
	onCancel: () => void;
	onSave: (event: any) => void;
	onSelectAllChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onColumnChange: (col: string, event: React.ChangeEvent<HTMLInputElement>) => void;
	columnNames: string[];
	tempVisibleColumns: string[];
	selectAll: boolean;
};

const ColumnSelectorDialog: React.FC<ColumnSelectorDialogProps> = ({
	open,
	onClose,
	onCancel,
	onSave,
	onSelectAllChange,
	onColumnChange,
	columnNames,
	tempVisibleColumns,
	selectAll
}) => {
	const columnsPerList = 10;
	const columnGroups = Array.from({ length: Math.ceil(columnNames.length / columnsPerList) }, (_, i) =>  // NOSONAR
		columnNames.slice(i * columnsPerList, i * columnsPerList + columnsPerList)
	);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="dialog-title"
			aria-describedby="dialog-description"
			onClick={(e) => e.stopPropagation()}
			onMouseDown={(e) => e.stopPropagation()}
			onContextMenu={(e) => e.stopPropagation()}
			sx={{
				'& .MuiDialog-paper': {
					p: '2px !important',
					borderRadius: 2
				},
				zIndex: 9999
			}}
		>
			<DialogActions onClick={(e) => e.stopPropagation()} onContextMenu={(e) => e.stopPropagation()}>
				<IconButton onClick={onSave} size="small">
					<CheckIcon sx={{ color: '#00B9FF' }} />
				</IconButton>
				<IconButton onClick={onCancel} size="small">
					<CloseIcon sx={{ color: '#00B9FF' }}/>
				</IconButton>
			</DialogActions>

			<DialogContent
				onClick={(e) => e.stopPropagation()}
				onContextMenu={(e) => e.stopPropagation()}
				sx={{
					px: 1,
					py: 1
				}}
			>
				<Stack direction="column" spacing={0}>
					<List dense sx={{ p: 0 }}>
						<ListItem
							disablePadding
							sx={{
								minHeight: '24px',
								py: 0,
								my: 0,
								'& .MuiFormControlLabel-root': {
									m: 0
								}
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={selectAll}
										onChange={onSelectAllChange}
										color="success"
										sx={{
											color: '#00D08D',
											'&.Mui-checked': {
												color: '#00D08D !important'
											}
										}}
									/>
								}
								label="Select All"
							/>
						</ListItem>
					</List>

					{columnNames.map((col, idx) => {
						if (col === "HeaderCheckboxMapping" || col === "Actions") return null;
						return (
						<List key={col} dense sx={{ p: 0, pt: 0, pb: 0 }}>
							<ListItem
								key={col}
								disablePadding
								sx={{
									minHeight: '24px',
									paddingTop: '0px',
									paddingBottom: '0px',
									marginTop: '0px',
									marginBottom: '0px',
									'& .MuiFormControlLabel-root': {
										margin: 0
									}
								}}
							>
								<FormControlLabel
									control={
										<Checkbox
											checked={tempVisibleColumns.includes(col)}
											onChange={(e) => {
												e.stopPropagation();
												onColumnChange(col, e);
											}}
											disabled={idx === 0}
											name={col}
											sx={{
												color: '#00D08D',
												'&.Mui-checked': {
													color: '#00D08D !important'
												},
												'&.Mui-disabled': {
													color: 'rgba(0, 0, 0, 0.80) !important'
												}
											}}
										/>
									}
									label={col}
								/>
							</ListItem>
						</List>
					)})}
				</Stack>
			</DialogContent>
		</Dialog>
	);
};

export default ColumnSelectorDialog;
